// One vocabulary for the comms log, matching stateOfMessage in the backend controller.
export const commsStates = {
  sent: {
    label: "Sent",
    hint: "Delivered into the vendor group chat.",
    className: "bg-green-100 text-green-700",
  },
  failed: {
    label: "Failed",
    hint: "The send was attempted and did not reach the group.",
    className: "bg-red-100 text-red-700",
  },
  scheduled: {
    label: "Scheduled",
    hint: "Waiting for its send time.",
    className: "bg-blue-100 text-blue-700",
  },
  overdue: {
    label: "Overdue",
    hint: "Its send time has passed and it has not gone out yet.",
    className: "bg-orange-100 text-orange-700",
  },
  awaitingAdmin: {
    label: "Waiting on Beleef",
    hint: "Held for a Beleef admin before the agent can see it.",
    className: "bg-purple-100 text-purple-700",
  },
  awaitingAgent: {
    label: "Waiting on agent",
    hint: "With the agent for approval.",
    className: "bg-yellow-100 text-yellow-800",
  },
  stopped: {
    label: "Stopped",
    hint: "A Beleef admin stopped it before it went out.",
    className: "bg-mediumgray text-darkergray",
  },
  rejected: {
    label: "Rejected",
    hint: "The agent chose not to send it.",
    className: "bg-lightgray text-darkergray",
  },
  skipped: {
    label: "Skipped",
    hint: "Closed without being sent.",
    className: "bg-lightgray text-darkergray",
  },
  notApplicable: {
    label: "Not applicable",
    hint: "This campaign never needed it.",
    className: "bg-lightgray text-darkergray",
  },
  expired: {
    label: "Expired",
    hint: "Nobody actioned it in 24 hours, so it was never sent.",
    className: "bg-red-50 text-red-700",
  },
};

// "skipped" used to cover four unrelated causes; these name them.
export const skipReasons = {
  noDecision24h: "The agent did not action it within 24 hours.",
  windowMissed: "It missed its dispatch window.",
  duplicate: "Another campaign record already sent the same message.",
  sendFailed: "The send failed.",
  superseded: "A later campaign event replaced it.",
  marketingCommitted: "The marketing campaign was paid or financed.",
  amendmentsSent: "The amendments message already gave the owners this link.",
  campaignCalledOff: "The campaign was cancelled before the listing went live.",
};

// Past tense, so the detail panel reads as a sentence.
export const adminActions = {
  stopped: "stopped",
  resent: "resent",
  retracted: "retracted",
  manualSend: "generated and sent",
  approved: "approved and sent to the agent",
  recalled: "took back",
};

// The message picker's headings, in the order it lists them. The two shapes of the
// 2am incident lead.
export const templateStateGroups = [
  { state: "readyNeverSent", heading: "Written, but never sent" },
  { state: "open", heading: "Never generated" },
  { state: "sent", heading: "Already sent" },
  { state: "closed", heading: "Closed off, will not run again" },
  { state: "noSlot", heading: "Not part of this property's campaign" },
];

// Why a manual trigger produced nothing. The generator itself is the source of truth.
export const previewReasons = {
  noGenerator: "No scheduled generator writes this template.",
  noTemplate: "This template does not exist.",
  noCampaign: "This property has no vendor comms campaign.",
  noSlot: "The campaign has no slot for this template.",
  alreadyGenerated: "The message already exists.",
  slotDecided: "The slot was already closed.",
  candidateExcluded: "The generator does not select this property.",
  runtimeCondition: "A condition inside the generator stopped it.",
  generatorError: "The generator errored.",
  runFailed: "The generator could not be run.",
  busy: "Another manual trigger is still running.",
};

export const stateOptions = [
  { value: "", label: "All statuses" },
  ...Object.entries(commsStates).map(([value, meta]) => ({
    value,
    label: meta.label,
  })),
];

export const windowOptions = [
  { value: 7, label: "Last 7 days" },
  { value: 30, label: "Last 30 days" },
  { value: 90, label: "Last 90 days" },
  { value: 365, label: "Last 12 months" },
];

export const formatSydney = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};
